import Typography from "@mui/material/Typography";

/** The `DescriptionFieldTemplate` is the template to use to render the description of a field
 *
 * @param props - The `DescriptionFieldProps` for this component
 */
export default function DescriptionFieldTemplate(props) {
  const { id, description } = props;
  if (description) {
    return (
      <Typography id={id} variant="subtitle2" fontSize={12} bgcolor="info.lighter" borderRadius={1} color="info.darker" px={2} py={1}>
        {description}
      </Typography>
    );
  }

  return null;
}
